export default __webpack_public_path__ + "static/media/p_wdt_c_1.1ce1b40d.mp3";